import { useState, useCallback, useEffect } from 'react';
import move from 'ramda/es/move';

import { Complexes } from '../useKits';
import { ComplexesListItem } from 'app/common/types/food/schools/complexes/sort';



type State = {
  kitList: Array<ComplexesListItem>
  modified: boolean
}

type Handlers = {
  moveItem: (indexFrom: number, indexTo: number) => Promise<void>,
  resetModified: () => void
  resetSort: () => void
}

type Options = {
  kits: Complexes
}


export function useSortKitsState({
  kits
}: Options): [State, Handlers] {
  const [modified, setModified] = useState<boolean>(false)
  const [kitList, setKitList] = useState<Array<ComplexesListItem>>([]);

  // Начальная инициализация категорий
  const initKits = useCallback(async (kits_: Complexes) => {
    const kitsList: ComplexesListItem[] = Object
      .values(kits_)
      .sort((a, b) => a.position - b.position)
      .map((k, index) => ({
        id: k.id,
        title: k.title,
        index
      }))

    setKitList(kitsList);
  }, []);



  // движение элемента с индексом indexFrom на позицию indexTo
  const moveItem = useCallback(async (indexFrom: number, indexTo: number) => {
    if (
      indexFrom < 0
      || indexTo < 0
      || indexFrom > kitList.length - 1
      || indexTo > kitList.length - 1
    ) {
      // Элементы вне списка не существуют, а значит и не двигаются
      return;
    }
    // -> move
    setModified(true)
    const newKitsList = move(indexFrom, indexTo, kitList);
    setKitList(newKitsList);
  }, [kitList]);

  const resetModified = useCallback(() => {
    setModified(false)
  }, [])

  const handleResetSort = useCallback(() => {
    initKits(kits)
    setModified(false)
  }, [kits, initKits])

  useEffect(() => {
    initKits(kits)
    setModified(false)
  }, [kits, initKits])

  return [{
    kitList,
    modified
  }, {
    moveItem,
    resetModified,
    resetSort: handleResetSort
  }];
}
